import React from 'react';
import { Container, Paper, Typography } from '@mui/material';
export default function LinkProblemPage({ agentName }) {
  return (<Container maxWidth="sm" sx={{ py: 8 }}><Paper sx={{ p: 4, textAlign: 'center' }}>
    <Typography variant="h5" gutterBottom>This link isn't available</Typography>
    <Typography color="text.secondary">It may have expired or been replaced. Please contact {agentName || 'your representative'} for a new link.</Typography>
  </Paper></Container>);
}
